import { theme } from '@procurify/ui-theme'
import styled, { keyframes } from 'styled-components'

const animation = keyframes`
  0% {transform: rotate(0deg)}
  50% {transform: rotate(180deg)}
  100% {transform: rotate(360deg)}
`

export interface ICircleLoaderProps {
  size?: number
  sizeUnit?: string
  color?: string
  strokeWidth?: number
}

export const CircleLoader = styled.div<ICircleLoaderProps>`
  width: ${(props) => `${props.size}${props.sizeUnit}`};
  height: ${(props) => `${props.size}${props.sizeUnit}`};
  border-top: ${(props) => `${props.strokeWidth}px solid ${props.color}`};
  border-right: ${(props) => `${props.strokeWidth}px solid ${props.color}`};
  border-bottom: ${(props) => `${props.strokeWidth}px solid transparent`};
  border-radius: 50%;
  display: inline-block;
  animation: ${animation} 0.75s 0s infinite linear;
`

CircleLoader.defaultProps = {
  color: theme.colors.white,
  size: 18,
  sizeUnit: 'px',
  strokeWidth: 2,
}
